import qs from 'qs'

import config from '../../config'

const getWorkOrderByIdsRequest = (params = {}, queryObject) => {
  const { airportId } = params

  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/${airportId}/WorkOrders/GetByIds${queryString}`,
  }
}

export default getWorkOrderByIdsRequest
